import { useEffect, useState } from "react";
import { CustomModal, TextInput, FormError, showToast } from "../shared";
import { useUpdateTeam } from "../../lib/react-query/teams";

const EditTeamModal = ({ isOpen, onClose, teamId, team }) => {
  const { mutateAsync: updateTeam, isLoading } = useUpdateTeam();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && team) {
      setName(team.name || "");
      setDescription(team.description || "");
      setError(null);
    }
  }, [isOpen, team]);

  const handleSave = async () => {
    try {
      if (!name.trim()) {
        setError("Team name is required.");
        return;
      }
      setError(null);
      const payload = { name: name.trim(), description: description.trim() || undefined };
      await updateTeam({ teamId, payload });
      showToast("Team updated successfully", "success", { position: "top-center" });
      onClose();
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        "Failed to update team.";
      setError(msg);
    }
  };

  return (
    <CustomModal
      title="Edit team"
      open={isOpen}
      close={onClose}
      primaryButtonText="Save changes"
      primaryButtonClick={handleSave}
      primaryButtonLoading={isLoading}
      secondaryButtonText="Cancel"
      secondaryButtonClick={onClose}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm leading-6 text-grey">
          Update team details visible to everyone in this workspace.
        </p>
        <TextInput
          label="Team name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="My team"
          required
        />
        <TextInput
          label="Description"
          name="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="What does this team do?"
        />
        <FormError message={error} />
      </div>
    </CustomModal>
  );
};

export default EditTeamModal;
